import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { TimePicker } from '@material-ui/pickers'
import moment from 'moment'

export default function HotSwapTimePicker({ onTimeChange }) {
    const classes = useStyles()

    useEffect(() => {
        onTimeChange(moment().format('HH:mm'))
    }, [])

    const handleTimeChange = value => {
        onTimeChange(value.format('HH:mm'))
    }

    return (
        <div className={classes.container}>
            <TimePicker
                open={true}
                isLandscape={true}
                variant="static"
                ampm={false}
                value={moment()}
                onChange={handleTimeChange}
            />
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        '& .MuiPickersToolbar-toolbar': {
            height: 80,
            borderRadius: '8px 8px 0 0'
        },
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #F2F4F7',
        padding: 3,
        display: 'flex',
        justifyContent: 'center',
        boxShadow:
            '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)'
    }
}))
